import { atom } from "recoil";
import { DocsTreeNode } from "../../../local-interfaces/docs";
import { DOCUMENTAZIONE } from "../../../config/docs";

export const docsTreeAtom = atom<DocsTreeNode[]>({
  key: "docsTree",
  default: DOCUMENTAZIONE
});